import _ from 'lodash';

import config from '../../../../config/config';

export const EDIT_RULES_FAILURE = 'RULES/EDIT_RULES_FAILURE';
export const EDIT_RULES_LOAD = 'RULES/EDIT_RULES_LOAD';
export const EDIT_RULES_SUCCESS = 'RULES/EDIT_RULES_SUCCESS';

export const RULES_FAILURE = 'RULES/RULES_FAILURE';
export const RULES_LOAD = 'RULES/RULES_LOAD';
export const RULES_SUCCESS = 'RULES/RULES_SUCCESS';

export const fetchUrl = `${config.paymentApiUrl}/paymentRules`;

export function editRules(userName, rules) {
    return {
        failureActionTypeOrCreator: editRulesFailureActionCreator,
        fetchParams: {
            method: 'POST',
            url: `${fetchUrl}`,
            body: {
                userName,
                rules
            }
        },
        loadActionTypeOrCreator: EDIT_RULES_LOAD,
        successActionTypeOrCreator: EDIT_RULES_SUCCESS
    };
}

export function editRulesFailureActionCreator(error) {
    return {
        error,
        type: EDIT_RULES_FAILURE
    };
}

export function getRulesFailureActionCreator(error) {
    return {
        error,
        type: RULES_FAILURE
    };
}

export function getRulesSuccessActionCreator(results) {
    return {
        count: _.size(results.rules),
        pages: 1,
        rules: results.rules,
        type: RULES_SUCCESS
    };
}

export function getRules(userName) {
    return {
        failureActionTypeOrCreator: getRulesFailureActionCreator,
        fetchParams: {
            url: `${fetchUrl}/${userName}`
        },
        loadActionTypeOrCreator: RULES_LOAD,
        successActionTypeOrCreator: getRulesSuccessActionCreator
    };
}
